"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.JovianOutpost = void 0;
var Tags_1 = require("../../Tags");
var PreludeCard_1 = require("../../prelude/PreludeCard");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var CardRenderDynamicVictoryPoints_1 = require("../../render/CardRenderDynamicVictoryPoints");
var Resources_1 = require("../../../Resources");
var JovianOutpost = (function (_super) {
    __extends(JovianOutpost, _super);
    function JovianOutpost() {
        return _super.call(this, {
            name: CardName_1.CardName.JOVIAN_OUTPOST,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SPACE],
            metadata: {
                cardNumber: 'L423',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(1).titanium(1); }).br;
                    b.vpText('1 VP per 2 Jovian tags you have.');
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.jovians(1, 2),
            },
        }) || this;
    }
    JovianOutpost.prototype.getVictoryPoints = function (player) {
        return Math.floor(player.getTagCount(Tags_1.Tags.JOVIAN, false, false) / 2);
    };
    JovianOutpost.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        player.addProduction(Resources_1.Resources.TITANIUM, 1);
        return undefined;
    };
    return JovianOutpost;
}(PreludeCard_1.PreludeCard));
exports.JovianOutpost = JovianOutpost;
//# sourceMappingURL=JovianOutpost.js.map